export const MulticriteriaTypesMap = {
    autoParts: 'AutoParts',
    tireRetail: 'TireRetail',
    tireTruck: 'TireTruck'
};



// WEBPACK FOOTER //
// ./src/enuns/AfterSales/multicriteriaTypes.enum.js